<template>
  <div id="legal-mention-page">
    <div id="head-contact" class="bg-grad">
      <h2 class="text-white">{{ $t("legalMention.title") }}</h2>
    </div>

    <section class="container my-5">
      <div class="mb-5 text-container">
        <h2 class="fw-bold display-6 text-primary">
          {{ $t("legalMention.legalSection.title") }}
        </h2>

        <h3>{{ $t("legalMention.legalSection.generalInfo.title") }}</h3>
        <p>
          <strong>{{
            $t("legalMention.legalSection.generalInfo.ownerLabel")
          }}</strong>
          {{ $t("legalMention.legalSection.generalInfo.ownerValue") }}<br />

          <strong>{{
            $t("legalMention.legalSection.generalInfo.websiteLabel")
          }}</strong>
          www.educspe.be<br />

          <strong>{{
            $t("legalMention.legalSection.generalInfo.emailLabel")
          }}</strong>
          contact@educspe.be<br />

          <strong>{{
            $t("legalMention.legalSection.generalInfo.hqLabel")
          }}</strong>
          {{ $t("legalMention.legalSection.generalInfo.hqValue") }}
        </p>

        <p>
          <strong>{{ $t("legalMention.legalSection.publisher.title") }}</strong
          ><br />
          {{ $t("legalMention.legalSection.publisher.text") }}
        </p>

        <p>
          <strong>{{ $t("legalMention.legalSection.hosting.title") }}</strong
          ><br />
          {{ $t("legalMention.legalSection.hosting.provider") }}<br />
          {{ $t("legalMention.legalSection.hosting.address") }}<br />
          {{ $t("legalMention.legalSection.hosting.url") }}
        </p>

        <h3>{{ $t("legalMention.legalSection.ip.title") }}</h3>
        <p>{{ $t("legalMention.legalSection.ip.text") }}</p>

        <h3>{{ $t("legalMention.legalSection.liability.title") }}</h3>
        <p>{{ $t("legalMention.legalSection.liability.text") }}</p>

        <h3 class="fw-bold display-6 text-primary">
          {{ $t("legalMention.rgpdSection.title") }}
        </h3>

        <h3>{{ $t("legalMention.rgpdSection.controller.title") }}</h3>
        <p>{{ $t("legalMention.rgpdSection.controller.text") }}</p>

        <h3>{{ $t("legalMention.rgpdSection.dataCollected.title") }}</h3>
        <ul>
          <li>
            {{ $t("legalMention.rgpdSection.dataCollected.items.item1") }}
          </li>
          <li>
            {{ $t("legalMention.rgpdSection.dataCollected.items.item2") }}
          </li>
          <li>
            {{ $t("legalMention.rgpdSection.dataCollected.items.item3") }}
          </li>
          <li>
            {{ $t("legalMention.rgpdSection.dataCollected.items.item4") }}
          </li>
          <li>
            {{ $t("legalMention.rgpdSection.dataCollected.items.item5") }}
          </li>
        </ul>

        <h3>{{ $t("legalMention.rgpdSection.purposes.title") }}</h3>
        <p>{{ $t("legalMention.rgpdSection.purposes.intro") }}</p>
        <ul>
          <li>{{ $t("legalMention.rgpdSection.purposes.items.item1") }}</li>
          <li>{{ $t("legalMention.rgpdSection.purposes.items.item2") }}</li>
          <li>{{ $t("legalMention.rgpdSection.purposes.items.item3") }}</li>
          <li>{{ $t("legalMention.rgpdSection.purposes.items.item4") }}</li>
        </ul>

        <h3>{{ $t("legalMention.rgpdSection.legalBasis.title") }}</h3>
        <p>{{ $t("legalMention.rgpdSection.legalBasis.text") }}</p>

        <h3>{{ $t("legalMention.rgpdSection.retention.title") }}</h3>
        <ul>
          <li>{{ $t("legalMention.rgpdSection.retention.items.item1") }}</li>
          <li>{{ $t("legalMention.rgpdSection.retention.items.item2") }}</li>
          <li>{{ $t("legalMention.rgpdSection.retention.items.item3") }}</li>
        </ul>

        <h3>{{ $t("legalMention.rgpdSection.sharing.title") }}</h3>
        <p>
          {{ $t("legalMention.rgpdSection.sharing.textLine1") }}<br />
          {{ $t("legalMention.rgpdSection.sharing.textLine2") }}
        </p>

        <h3>{{ $t("legalMention.rgpdSection.security.title") }}</h3>
        <p>{{ $t("legalMention.rgpdSection.security.text") }}</p>

        <h3>{{ $t("legalMention.rgpdSection.rights.title") }}</h3>
        <p>{{ $t("legalMention.rgpdSection.rights.intro") }}</p>
        <ul>
          <li>{{ $t("legalMention.rgpdSection.rights.items.item1") }}</li>
          <li>{{ $t("legalMention.rgpdSection.rights.items.item2") }}</li>
          <li>{{ $t("legalMention.rgpdSection.rights.items.item3") }}</li>
          <li>{{ $t("legalMention.rgpdSection.rights.items.item4") }}</li>
          <li>{{ $t("legalMention.rgpdSection.rights.items.item5") }}</li>
          <li>{{ $t("legalMention.rgpdSection.rights.items.item6") }}</li>
        </ul>

        <p>
          {{ $t("legalMention.rgpdSection.rights.howTo") }}
          <strong>{{
            $t("legalMention.rgpdSection.rights.contactEmail")
          }}</strong>
        </p>

        <h3>{{ $t("legalMention.rgpdSection.cookies.title") }}</h3>
        <p>{{ $t("legalMention.rgpdSection.cookies.text") }}</p>

        <h3>{{ $t("legalMention.rgpdSection.policyUpdate.title") }}</h3>
        <p>{{ $t("legalMention.rgpdSection.policyUpdate.text") }}</p>
      </div>
    </section>

    <!-- CALL TO ACTION -->
    <Cta />
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import Cta from "@/components/Cta.vue";

export default {
  name: "LegalMention",
  components: {
    Cta,
  },
  setup() {
    const { t } = useI18n();

    useHead(() => ({
      title: t("legalMention.meta-data.title"),
      meta: [
        {
          name: "description",
          content: t("legalMention.meta-data.desc"),
        },
      ],
    }));
  },
};
</script>

<style scoped>
#head-contact {
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
